import { render, staticRenderFns } from "./WorldOutgo.vue?vue&type=template&id=21e1ca3f&scoped=true&"
import script from "./WorldOutgo.vue?vue&type=script&lang=js&"
export * from "./WorldOutgo.vue?vue&type=script&lang=js&"
import style0 from "./WorldOutgo.vue?vue&type=style&index=0&id=21e1ca3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1ca3f",
  null
  
)

export default component.exports